const getStylesAndCollissions = (getPosition, triggerRect, tooltipRect, position)=>{
    const haventMeasuredTooltipYet = !tooltipRect;
    if (haventMeasuredTooltipYet) return [
        {
            visibility: 'hidden'
        },
        {
            bottom: false,
            left: false,
            top: false,
            right: false
        }
    ];
    return getPosition(triggerRect, tooltipRect, position);
};
const helpers_getStylesAndCollissions = getStylesAndCollissions;
export default helpers_getStylesAndCollissions;
